module.exports = __webpack_public_path__ + "img/sequence-miyashita-park-sp.ac1406c5.jpg";